// Static labels the UI needs but the API has no reason to serve: the channel
// vocabulary itself, and what each channel calls its counterparty.

export const CHANNELS = [
  { id: 'd2c', name: 'D2C', full: 'Direct-to-Consumer (Walk-in)' },
  { id: 'b2b', name: 'B2B', full: 'B2B (Partner / Reference Labs)' },
  { id: 'corp', name: 'Corporate', full: 'Corporate Contracts' },
  { id: 'govt', name: 'Government', full: 'Government Contracts' },
  { id: 'hosp', name: 'Hospitals & Clinics', full: 'Hospitals, Clinics & Others' },
];

// Which party column a channel is keyed by, and what to call it.
export const PARTY = {
  d2c: { label: 'Champion', key: 'champion' },
  b2b: { label: 'Lab / Franchisee', key: 'client' },
  corp: { label: 'Corporate', key: 'client' },
  govt: { label: 'Govt Body / Contract', key: 'client' },
  hosp: { label: 'Hospital / Clinic', key: 'client' },
};

export const ROLE_DESC = {
  Admin: 'Full access · manage users & shares',
  Manager: 'Edit channel data & shares',
  Analyst: 'View dashboards & export',
  Viewer: 'Read-only dashboards',
};
